module.exports = __webpack_public_path__ + "img/T15.9dfdc834.jpg";